export const APP_ROUTES = {
    DASHBOARD: '/',
    SHARECALL: '/sharecall/:id/:type',
    EPRECRIPTION: '/eprescription',
}